<template>
  <div id="follow">
    <template v-if="step == 2">
      <div class="searcher"><input v-model="search" type="text" /></div>

      <!-- <template v-if="search != ''"> -->
      <template>
        <div class="clubs">
          <div
            v-for="club in results"
            :key="club.id"
            class="item"
            @click="select(club.id)"
          >
            <cld-image
              class="logo"
              :publicId="club.shield"
              type="fetch"
              loading="lazy"
            >
              <cld-transformation
                height="100"
                radius="3"
                crop="fill"
                fetchFormat="auto"
              />
            </cld-image>

            <span class="name">{{ club.name }}</span>
          </div>
        </div>
      </template>
    </template>

    <template v-else-if="step == 3">
      <div
        class="back"
        @click="
          step = 2;
          new_follow = false;
        "
      >
        <cld-image
          class="logo"
          :publicId="club.shield"
          type="fetch"
          loading="lazy"
        >
          <cld-transformation
            height="100"
            radius="3"
            crop="fill"
            fetchFormat="auto"
          />
        </cld-image>

        <span class="name">{{ club.name }}</span>
      </div>
      <div class="teams">
        <router-link
          v-for="team in club.teams"
          :key="team.id"
          class="item"
          :to="'/team/' + team.id"
        >
          <span class="name">{{ team.category }}</span>
        </router-link>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "Teams",
  data() {
    return {
      step: 2,
      search: "",
      club: false
    };
  },
  computed: {
    clubs() {
      return this.$store.getters["competition/getClubs"]();
    },
    results() {
      var results = [];
      var data = this.clubs;
      var searchInput = cleanString(this.search.trim().toLowerCase());

      if (searchInput == "") {
        results = [...Object.values(data)];
        results.sort(function(a, b) {
          console.log(a.name, b.name, a.name < b.name);
          return a.name < b.name ? -1 : 1;
        });
        return results;
      }

      for (var idx in data) {
        var item = data[idx];

        var name = cleanString(item.name.trim().toLowerCase());

        if (searchInput != "") {
          const searchRegex = new RegExp(searchInput, "g");
          if (name.match(searchRegex)) {
            results.push(item);
          }
        }
      }

      results.sort(function(a, b) {
        console.log(a.name, b.name, a.name < b.name);
        return a.name < b.name ? -1 : 1;
      });

      return results;
    }
  },
  methods: {
    select(clubId) {
      this.step = 3;
      this.club = this.clubs[clubId];
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  created() {
    // this.$store.dispatch("competition/loadClubs").then(function() {});
  }
};
</script>

<style lang="scss" scoped>
#follow {
  max-width: 1000px;
  margin: 0 auto;
}
.list {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-gap: 10px;
  column-gap: 10px;
  row-gap: 10px;
  text-align: center;

  .item {
    background-color: #fff;
    color: #222;
    height: 150px;
    border-radius: 4px;
    padding: 20px 10px;
    align-items: center;
    display: flex;
    flex-direction: column;
    background-size: 25px;
    background-position: top 10px right 10px;
    background-image: url("~@/../public/img/star_selected.svg");
    background-repeat: no-repeat;
    background-color: #fff;

    &.add {
      background-size: 60px;
      background-position: center top 30px;
      background-image: url("~@/../public/img/add.svg");
      background-repeat: no-repeat;
      background-color: $secondary-color;
      padding-top: 100px;
    }

    .logo {
      height: 60px;
      margin-bottom: 10px;
    }
    .category {
      font-family: $font-title;
    }
    .name {
      font-family: $font-text;
      font-size: 14px;
    }
  }
}

.button {
  max-width: 450px;
  margin: 0 auto;
}

.searcher {
  background-size: 20px;
  background-position: center right 10px;
  background-image: url("~@/../public/img/search.svg");
  background-repeat: no-repeat;
  width: 100%;
  border-radius: 4px;
  margin-bottom: 15px;
  background-color: #fff;
  text-align: left;
  input {
    width: calc(100% - 30px);
    height: 40px;
    border: none;
    outline: none;
    padding: 10px;
    font-size: 18px;
  }
}

.back {
  display: flex;
  align-items: center;
  width: fit-content;
  .logo {
    width: 25px;
    margin-left: 10px;
  }
  .name {
    padding-left: 10px;
    padding-right: 20px;
    font-family: $font-title;
    color: #222;
    font-size: 14px;
  }
}

.clubs {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-gap: 10px;
  margin-bottom: 15px;

  .item {
    background-size: 20px;
    background-position: center right 10px;
    background-image: url("~@/../public/img/left_arrow.svg");
    background-repeat: no-repeat;
    background-color: #fff;
    border-radius: 4px;
    width: 100%;
    padding: 10px;
    display: flex;
    align-items: center;
    cursor: pointer;

    .logo {
      width: 15%;
    }
    .name {
      width: 85%;
      padding-left: 10px;
      padding-right: 20px;
      font-family: $font-title;
    }
  }
}

.teams {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-gap: 10px;
  margin-bottom: 15px;

  .item {
    background-color: #fff;
    border-radius: 4px;
    width: 100%;
    padding: 10px;
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #222;
    cursor: pointer;

    .name {
      width: calc(100%);
      padding-left: 10px;
      padding-right: 20px;
      font-family: $font-title;
    }
  }
}

.tablet {
  .clubs {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
  }
  .teams {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
  }
  .list {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
  }
}
.laptop {
  .clubs {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) !important;
  }
  .teams {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) !important;
  }
  .list {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) !important;
  }
}
.desktop {
  .clubs {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) !important;
  }
  .teams {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) !important;
  }
  .list {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) !important;
  }
}
</style>
